import { LinkProps } from "react-aria-components";
import { MDSTextVariant } from "../text/text.types";
import { StyledLink } from "./link.style";

export interface IMDSLinkProps extends React.PropsWithChildren<LinkProps> {
  variant?: MDSTextVariant;
}

export function MDSLink({ children, variant, ...rest }: IMDSLinkProps) {
  return (
    <StyledLink $variant={variant} {...rest}>
      {children}
    </StyledLink>
  );
}
